export default __webpack_public_path__ + "static/media/category_tshirt.6c6e6d56.webp";